export enum HapticPattern
{
  LIGHT = "light",
  MEDIUM = "medium",
  HEAVY = "heavy"
}

export interface HapticStrength
{
  amplitude: number;
  duration: number;
}

// These are the values at HapticsController strength = 100% (its amplitude multiplier
// scales down from here, see getNativeStrength()). All three used to be identical
// (duration:15, amplitude:130/255) - Android never felt LIGHT/MEDIUM/HEAVY as
// different intensities, and 100% strength topped out at ~51% of the device's real
// output. HEAVY's amplitude is now 255 - the actual native ceiling, VibrationEffect
// accepts nothing higher - confirmed on-device via HAPTICS LOG that duration:40
// amplitude:255 still read as weak, so amplitude has no headroom left and duration
// is the only remaining lever. Bumped further: a 40ms pulse barely lets an ERM
// (non-LRA) motor - common on budget/midrange Android phones - spin up to full
// speed before it's cut off, so it reads as a faint tick instead of a solid thump.
export const HAPTIC_STRENGTH: Record<HapticPattern, HapticStrength> = {
  [HapticPattern.LIGHT]: { duration: 35, amplitude: 170 },
  [HapticPattern.MEDIUM]: { duration: 55, amplitude: 215 },
  [HapticPattern.HEAVY]: { duration: 85, amplitude: 255 },
};

export const HAPTIC_MAPPING: Readonly<Record<string, HapticPattern>> = {
  "ui_click": HapticPattern.LIGHT,

  "glass_cube_drop_1": HapticPattern.LIGHT,
  "glass_cube_drop_2": HapticPattern.LIGHT,
  "metal_cube_drop_1": HapticPattern.MEDIUM,
  "metal_cube_drop_2": HapticPattern.MEDIUM,
  "wood_cube_drop_1": HapticPattern.LIGHT,
  "wood_cube_drop_2": HapticPattern.LIGHT,

  "glass_cube_hit": HapticPattern.MEDIUM,
  "metal_cube_hit": HapticPattern.HEAVY,
  "wood_cube_hit": HapticPattern.MEDIUM,
  "cannon_shot": HapticPattern.HEAVY,

  "search_level": HapticPattern.LIGHT,
  "start_level": HapticPattern.MEDIUM,
  "lose_game": HapticPattern.HEAVY,
  "win_game": HapticPattern.MEDIUM,
};
